<div class="c-error-page">
  <div class="c-error-page__content" [@errorContent]>
    <h1 #pageTitle class="c-error-page__header" i18n="@@errorPage-title-error">
      Error!
    </h1>

    <h2 class="c-error-page__subheader" [ngSwitch]="isReportableError">
      <ng-container
        *ngSwitchCase="true"
        i18n="@@errorPage-status-somethingWrongTeamNotified"
        >Something has gone wrong, and our team has been notified</ng-container
      >
      <ng-container *ngSwitchDefault i18n="@@errorPage-status-somethingWrong"
        >Something has gone wrong</ng-container
      >
    </h2>

    <hr />

    <div class="c-error-page__context">
      <strong class="qa-error-page__context__summary">
        <ng-container *ngIf="code && title ? true : false"
          >{{ code }}: {{ title }}</ng-container
        >
        <ng-container *ngIf="code && !title">{{ code }}</ng-container>
        <ng-container *ngIf="title && !code">{{ title }}</ng-container>
        <ng-container
          *ngIf="!code && !title"
          i18n="@@errorPage-message-unknownErrorOccurred"
          >An unknown error has occurred</ng-container
        >
      </strong>

      <div *ngIf="detail ? true : false" class="qa-error-page__context__detail">
        {{ detail }}
      </div>
    </div>
  </div>
</div>
